<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- alert end -->
    <!-- Title-->
    <header-component :headerTitle="headerText"/>
    <div v-if="tour_action == 'create_tour_plan'" class="router_link">
      <span @click="backToTourPlan" style="color: #0357D0; cursor: pointer">Create</span>
      <span>
        <img class="my-1 image-align" src="@/assets/images/icons/expand_more.svg" width="7" height="10" />
        Create New Plan
      </span>
    </div>
    <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <Loading v-model:active="isLoading" :can-cancel="true" :is-full-page="fullPage" :color="primary_code"></Loading>
    <!-- Title end -->
    <!-- popups -->
    <!-- filter data popup -->
    <v-dialog content-class="filter-repair" v-model="filterDetails" persistent :max-width="dialogMaxWidth" width="700px;">
      <v-card class="mt-0 filter_ui">
        <v-card-actions>
          <!--  fields -->
            <v-col v-if="active_tab === 'History'">
              <v-combobox v-model="month_wise" :items="month_wise_items" item-title="name" item-value="id" label="Month" variant="outlined" color="primary"> </v-combobox>
            </v-col>
            <v-col v-if="active_tab === 'NDC'">
              <v-combobox v-model="dealer_filter" :items="dealer_filter_items" item-title="name" item-value="id" label="Dealer" variant="outlined" color="primary"> </v-combobox>
            </v-col>
            <v-col v-if="active_tab === 'History'">
              <v-combobox v-model="year_wise" :items="year_wise_items" item-title="name" item-value="id" label="Year" variant="outlined" color="primary" return-object > </v-combobox>
            </v-col>
            <v-col v-if="active_tab === 'NDC'">
              <v-combobox v-model="sales_manager_filter" :items="sales_manager_filter_items" item-title="name" item-value="id" label="Service Manager" variant="outlined" color="primary" return-object > </v-combobox>
            </v-col>
            <v-col v-if="active_tab === 'NDC'">
              <v-combobox v-model="current_cycle" :items="current_cycle_items" item-title="display" item-value="id" label="Cycle" variant="outlined" color="primary" return-object > </v-combobox>
            </v-col>
            <v-col v-if="(active_tab !== 'Create' || tour_action !== 'create_tour_plan') && active_tab !== 'Upcoming Visits' && active_tab !== 'History' && active_tab !== 'NDC'">
            <v-menu ref="filterFromDate" v-model="filterFromDate" :close-on-content-click="false" v-model:return-value="filter_from_date" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ props }">
                  <v-text-field variant="outlined" color="primary" v-model="formattedFromDatefilter" label="From" prepend-inner-icon="mdi-calendar" readonly v-bind="props" ></v-text-field>
              </template>
              <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerFromDateFilter" hide-header color="primary" min-width="200" max-width="300" scrollable>
                </v-date-picker>
                <v-card-action class="d-flex justify-end pb-3">
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" class="text-none" @click="filterFromDate = false">Cancel</v-btn>
                  <v-btn variant="text" color="primary" class="text-none" @click="handleSaveDate('filterFromDate', 'filter_from_date', 'isDatePickerFromDateFilter', true, '', '')">Ok</v-btn>
                </v-card-action>
              </v-card>
            </v-menu>
          </v-col>
          <v-col v-if="(active_tab !== 'Create' || tour_action !== 'create_tour_plan') && active_tab !== 'Upcoming Visits' && active_tab !== 'History' && active_tab !== 'NDC'">
            <v-menu ref="filterToDate" v-model="filterToDate" :close-on-content-click="false" v-madel:return-value="filter_to_date" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ props }">
                  <v-text-field variant="outlined" color="primary" v-model="formattedToDatefilter" label="To" prepend-inner-icon="mdi-calendar" readonly v-bind="props" ></v-text-field>
              </template>
              <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerToDateFilter" hide-header color="primary" min-width="200" max-width="300" scrollable>
                </v-date-picker>
                <v-card-action class="d-flex justify-end pb-3">
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" class="text-none" @click="filterToDate = false">Cancel</v-btn>
                  <v-btn variant="text" color="primary" class="text-none" @click="handleSaveDate('filterToDate', 'filter_to_date', 'isDatePickerToDateFilter', true, '', '')">Ok</v-btn>
                </v-card-action>
              </v-card>
            </v-menu>
          </v-col>
          <v-col v-if="active_tab === 'Approved Tour Plans' || active_tab === 'Approval Requests' || active_tab == 'History'">
              <v-combobox v-model="selected_designation" :items="[{id: 'Branch Service Manager', display: 'Branch Service Manager'}, {id: 'Area Service Manager', display: 'Area Service Manager'}]" item-title="display" item-value="id" label="Designation" variant="outlined" color="primary" return-object multiple > </v-combobox>
            </v-col>
          <v-col v-if="active_tab === 'Approved Tour Plans'">
            <v-combobox v-model="select_stage" :items="stage_items"
            variant="outlined" item-title="name" item-value="id" return-object @update:modelValue="changeStage()"></v-combobox>
          </v-col>
          

        </v-card-actions>
        <v-card-actions class="margin-10">
          <v-spacer></v-spacer>
          <v-btn class="text-none" variant="outlined" color="primary" @click="filterDetails = false" >Cancel</v-btn >
          <v-btn class="text-none" variant="flat" color="primary" @click="applyFilterFun()">Apply Filter(S)</v-btn >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete confirmation popup -->
    <v-row justify="center">
      <v-dialog v-model="deleteConfirmationPopup" persistent max-width="424px">
        <v-card class="v-card-100 mt-0">
          <v-card-text class="pt-14 text-center"> 
            <v-span>Are you sure want to delete this tour plan ? </v-span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" size="small" variant="outlined" class="mb-3 text-none" @click="deleteConfirmationPopup = false">Cancel</v-btn>
            <v-btn color="primary" size="small" variant="flat" class="mb-3 text-none" @click="deletePendingApprovalItems">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="approveRemarkPopup" persistent max-width="424px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex align-center">
            <span>Approve Tour Plan?</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="approveRemarkPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="text-center mt-5">
            <v-text-field v-model="add_remarks" label="Add remarks ( if Any )" variant="outlined"></v-text-field>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" size="small" variant="outlined" class="mb-3 text-none" @click="approveRemarkPopup = false">Cancel</v-btn>
            <v-btn color="primary" size="small" variant="flat" class="mb-3 text-none" @click="confirmApproveRequest">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- reject popup -->
    <v-row justify="center">
      <v-dialog v-model="rejectRemarkPopup" persistent max-width="424px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex align-center">
            <span>Reject Tour Plan?</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="rejectRemarkPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="text-center mt-5">
            <v-text-field v-model="reject_remarks" label="Add remarks ( if Any )" variant="outlined"></v-text-field>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" size="small" variant="outlined" class="mb-3 text-none" @click="rejectRemarkPopup = false">Cancel</v-btn>
            <v-btn color="primary" size="small" variant="flat" class="mb-3 text-none" @click="confirmRejectRequest">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="424px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon @click="successPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ SuccessMessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="closePopups">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="visitDateInfoPopup" persistent max-width="500px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex align-center">
            <span>Visit Date Info</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="visitDateInfoPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="text-center p-0 mt-2">
            <v-data-table hover
              density="compact"
              :style="dataTableStyle"
              :search="search"
              v-model="selected"
              disable-pagination
              :hide-default-footer="true"
              :headers="info_headers"
              :items="info_table_data"
              fixed-header
              height="100%" 
              :loading="loading"
              :items-per-page="pageSize"
              return-object
              loading-text="Loading Data... Please wait"
              class="elevation-1" >
            </v-data-table> 
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="pdfPopup" persistent max-width="800px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center" >
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="closePdfPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="text-right mt-2">
           <iframe :src="pdfViewerUrl" style="width: 100%; height: 550px; border: none; margin:0px"></iframe>
            <v-btn @click="downloadPdf" class="" color="primary">Download</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="remarksPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Add Remarks</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="remarksPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text class="text-center mt-5">
            <v-textarea v-model="reject_remarks" label="Type here..." variant="outlined"></v-textarea>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="confirmClose">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- closing remarks popup -->
    <v-row justify="center">
      <v-dialog v-model="remarksDetailsPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0">
            <v-card-title class="d-flex">
              <span>Closing Remarks</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="remarksDetailsPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-card-text class="text-center mt-3" style="color:rgba(0,0,0,.6)">
            <span>{{ message }}</span>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Tabs -->
  <v-card class="v-card-100 mt-6" v-if="tour_action !== 'create_tour_plan'">
    <v-tabs v-model="tab_index" color="primary">
      <v-tab style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked', index)" v-for="(tab, index) in tabs1" :key="index" class="tab-color" :disabled="(tab === 'Create' || tab === 'Approval Requests') && (role === 'admin' && organization_name !== 'Blubirch')">{{ tab }}</v-tab>
    </v-tabs>
  </v-card>
    <!-- tabs end -->
    <!-- search actions filter-->

    <v-card-title style="padding: 23px 28px 16px 28px;" class="action-style mt-6" v-if="active_tab !== 'Create' || tour_action !== 'create_tour_plan'">
      <!-- Search Fields -->
      <v-row class="mb-0">
          <v-autocomplete v-model="select_field" :items="select_field_items"  item-value="id" style="max-width: 150px;max-height: 56px; height: 62px;" item-title="name" label="Select Field" class="mr-4 search_style mt-1" variant="outlined" v-if="active_tab == 'NDC'"></v-autocomplete >
          <v-text-field prepend-inner-icon="mdi-magnify" variant="outlined" v-model="search_tag" label="Search" style="max-width: 300px; height: 62px;" class="search_style" v-on:keyup.enter="loadData(active_tab)" density="comfortable" hide-details></v-text-field>
          <DynamicHeader v-if="active_tab === 'Approval Requests' || active_tab === 'History'" :headers="headers" :totalHeaderList="complete_headers" :updateHeaders="updateHeaders" :componentKey="active_tab"/>
        <v-spacer></v-spacer>
        <v-col cols="3" sm="3" class="p-0">
          <v-card-actions style="display: flex; margin-bottom: 10px; padding-top: 4px" class="float-right" v-if="active_tab === 'Create' && tour_action !== 'create_tour_plan'">
            <v-btn variant="flat" color="primary" size="x-large"  class="text-none" :disabled="this.selected.length != 1" @click="editTourPlan">Edit</v-btn>
            <v-btn variant="flat" color="primary" size="x-large" class="text-none" :disabled="this.selected == 0" @click="deletePending">Delete</v-btn>
            <v-btn variant="flat" color="primary" size="x-large"  class="text-none" @click="createTourPlan">Create Plan</v-btn>
          </v-card-actions>
          <v-card-actions class="float-right pt-1" v-if="active_tab === 'Approval Requests'">
            <v-btn class="ma-2 mt-0 text-none" size="x-large" variant="outlined" color="primary" :disabled="selected.length == 0" @click="rejectTourPlan">Reject</v-btn>
            <v-btn class="ma-2 mt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="selected.length == 0" @click="approveTourPlan">Approve</v-btn>
          </v-card-actions>
          <v-card-actions class="float-right pt-1" v-if="active_tab === 'NDC'">
            <v-btn class="text-none" size="x-large" variant="flat" color="primary" :disabled="this.selected.length != 1 || selected[0].status != 'Pending'" @click="closeRequest">Close</v-btn>
          </v-card-actions>
        </v-col>
        <v-expansion-panels class="custom-control_outlined m-0 pt-1" ref="filterPopupRef" readonly v-if="active_tab !== 'Upcoming Visits'" style="max-width: 110px; margin-bottom: 16px; height: 52px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons" >
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
          <v-combobox v-model="upcoming_visits" :items="upcoming_visits_items" style="max-width: 150px;"  class="text-left pt-3" item-title="name" item-value="id" label="Filter" 
          variant="outlined" v-if="active_tab === 'Upcoming Visits'" return-object @update:modelValue="dateSelect"></v-combobox>
      </v-row>
    </v-card-title>
    <!-- search actions filter ends-->
    <!-- create tour plan -->
    <v-card class="v-card-100 mt-0" v-if="active_tab === 'Create' && tour_action == 'create_tour_plan'">
      <v-card-text style="padding: 32px;">
        <v-row>
          <v-col cols="4" class="pt-7 text-left">
            <span style="font-weight: 600;">Tour Plan Period</span>
          </v-col>
          <v-col cols="4">
            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" v-model:return-value="from_date" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ props }">
                  <v-text-field variant="outlined" color="primary" v-model="formattedFromDate" label="From" prepend-inner-icon="mdi-calendar" readonly v-bind="props" ></v-text-field>
              </template>
              <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                <v-date-picker :min="tommarow_date" :max="nextMonthEnd" v-model="isDatePickerFromDate" hide-header color="primary" min-width="200" max-width="300" scrollable :allowed-dates="startDateOfMonth">
                </v-date-picker>
                <v-card-action class="d-flex justify-end pb-3">
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" class="text-none" @click="menu1 = false">Cancel</v-btn>
                  <v-btn variant="text" color="primary" class="text-none" @click="handleSaveDate('menu1', 'from_date', 'isDatePickerFromDate', true, '', '')">Ok</v-btn>
                </v-card-action>
              </v-card>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" v-model:return-value="to_date" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ props }">
                  <v-text-field variant="outlined" color="primary" v-model="formattedToDate" label="To" prepend-inner-icon="mdi-calendar" readonly v-bind="props" ></v-text-field>
              </template>
              <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                <v-date-picker :min="tommarow_date" :max="nextMonthEnd" v-model="isDatePickerToDate" hide-header color="primary" min-width="200" max-width="300" scrollable :allowed-dates="allowDates">
                </v-date-picker>
                <v-card-action class="d-flex justify-end pb-3">
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" class="text-none" @click="menu2 = false">Cancel</v-btn>
                  <v-btn variant="text" color="primary" class="text-none" @click="handleSaveDate('menu2', 'to_date', 'isDatePickerToDate', true, '', '')">Ok</v-btn>
                </v-card-action>
              </v-card>
            </v-menu>
            <div v-if="error" class="error-message">{{ error }}</div>
            <div class="text-end">
              <v-btn color="primary" size="x-large" class="text-none" style="margin-top: 18px;" :disabled="!from_date || !to_date" @click="confirmDate">Continue</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="v-card-100 mt-0 select-card" v-if="selectMethod === true">
      <v-card-text style="padding: 32px;">
        <v-row>
          <v-col cols="4" class="pt-7 text-left">
            <span style="font-weight: 600;">Select Method</span>
          </v-col>
          <v-col cols="8">
            <v-radio-group inline v-model="selectDetails">
              <v-radio  :label="role == 'area_service_manager' ? 'Dealer Wise' : 'Service Manager Wise'" value="sales_manager_wise" style="margin-right: 409px;" class="radio-content"></v-radio>
              <v-radio  label="Date Wise" value="date_wise" class="radio-content"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="v-card-100 mt-0 select-card" v-if="selectDetails === 'sales_manager_wise'">
      <v-card-text style="padding: 32px;">
        <v-row v-for="(manager, index) in salesManagers" :key="index">
          <v-col cols="4" :class="{ 'pt-7': index === 0 }" class="text-left">
            <span v-if="index === 0" style="font-weight: 600;">Add Date</span>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="manager.sales_manager" label="Service Manager" variant="outlined">
              <template #append>
                <v-icon color="primary" cursor="pointer" @click="detailPopup(manager)">mdi-information-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <div v-for="(visitDate, visitIndex) in manager.visitDates" :key="visitIndex" class="d-flex">
              <v-menu v-model="visitDate.showDialog" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ props }">
                  <v-text-field variant="outlined" color="primary" v-model="visitDate.dateFormatted" label="Visit Date" prepend-inner-icon="mdi-calendar" readonly v-bind="props" :disabled="visitDate.disable"></v-text-field>
                </template>
                <v-card class="m-0 overflow-hidden calendar-layout" width="330">
                  <v-date-picker :min="from_date" :max="min_available_date" v-model="visitDate.date" no-title  :allowed-dates="date => allowDates1(date, index, visitIndex)"  @update:modelValue="updateFormattedDate(visitDate)" scrollable>
                  </v-date-picker>
                  <v-card-action class="d-flex justify-end pb-3">
                    <v-spacer></v-spacer>
                    <v-btn class="text-none" variant="text" color="primary" @click="handleCancel(visitDate, visitIndex,manager)">Cancel</v-btn>
                    <v-btn class="text-none" variant="text" color="primary" @click="visitDate.showDialog = false">Ok</v-btn>
                  </v-card-action>
                </v-card>
              </v-menu>
              <span class="ml-3 mt-4" style="font-size: 18px;" v-if="editAction === 'Create Tour Plan'">
                <v-icon v-if="visitIndex == 0" style="color: red;" @click="eraseDate(visitDate,manager,visitIndex)">mdi-eraser</v-icon>
                <v-icon v-else style="color: red;" @click="deleteDate(manager,visitIndex,visitDate)" :disabled="visitDate.disable">mdi-delete</v-icon>
              </span>
            </div>
            <!-- Add more button -->
            <div class="text-end">
              <a style="color: #1976d2; cursor: pointer;" @click="addVisitDateField(manager)">
                <u>+Add Date</u>
              </a>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" class="p-0">
            <v-card-actions class="float-right">
              <v-btn color="primary" variant="flat" class="text-none" @click="proceed">Create Plan</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="v-card-100  select-card" v-if="selectDetails === 'date_wise'">
      <v-card-text style="padding: 32px;">
      <div v-if="role != 'area_service_manager'">
        <v-row v-for="(manager, index) in salesManagersDateWise" :key="index">
          <v-col cols="4" :class="{ 'pt-7': index === 0 }">
            <span v-if="index === 0" style="font-weight: 600;">Add Dealers</span>
          </v-col>
          <v-col cols="4">
            <!-- <v-menu v-model="manager.visitDate2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field variant="outlined" v-model="manager.visit_date2" label="Visit Date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                  <template v-slot:append>
                    <v-icon color="primary" cursor="pointer" @click="detailPopup(manager)">mdi-information-outline</v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="manager.visit_date2" no-title scrollable @change="updateFormattedDateVisit(manager)">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="handleCancel2(manager)">Cancel</v-btn>
                <v-btn text color="primary" @click="manager.visitDate2 = false">OK</v-btn>
              </v-date-picker>
            </v-menu> -->
            <v-menu v-model="manager.visitDate2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ props }">
                    <v-text-field variant="outlined" color="primary" v-model="manager.formatted_visit_date2" label="Visit Date" prepend-inner-icon="mdi-calendar" readonly v-bind="props" :disabled="true">
                      <template v-slot:append>
                        <v-icon color="primary" cursor="pointer" @click="detailPopup(manager)">mdi-information-outline</v-icon>
                      </template>
                    </v-text-field>
                </template>
                <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                  <v-date-picker v-model="manager.visit_date2" hide-header color="primary" min-width="200" max-width="300" scrollable :allowed-dates="allowDates" @update:modelValue="updateFormattedDateVisit(manager)">
                  </v-date-picker>
                  <v-card-action class="d-flex justify-end pb-3">
                    <v-spacer></v-spacer>
                    <v-btn variant="text" color="primary" class="text-none" @click="handleCancel2(manager)">Cancel</v-btn>
                    <v-btn variant="text" color="primary" class="text-none" @click="manager.visitDate2 = false">Ok</v-btn>
                  </v-card-action>
                </v-card>
              </v-menu>
          </v-col>
          <v-col cols="4">
            <div v-for="(s_manager, visitIndex) in manager.manager_list" :key="visitIndex" class="d-flex text-left">
              <v-autocomplete v-model="s_manager.manager_name" :items="availableManagers(manager.manager_list, s_manager.manager_name)" item-title="sales_manager" item-value="sales_manager_id" label="Service Manager" variant="outlined"  :disabled="manager.disable"> </v-autocomplete>
              <span class="ml-3 mt-4" style="font-size: 18px;" v-if="editAction === 'Create Tour Plan'">
                <v-icon v-if="visitIndex == 0" style="color: red;" @click="eraseManager(s_manager)" :disabled="manager.disable">mdi-eraser</v-icon>
                <v-icon v-else style="color: red;" @click="deleteManager(manager.manager_list,visitIndex)" :disabled="manager.disable">mdi-delete</v-icon>
              </span>
            </div>
            <div class="text-end">
              <span style="color: #1976d2;cursor:pointer;" @click="addMoreManager(manager)" :disabled="manager.disable">
                +Add Service Manager
              </span>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-if="role == 'area_service_manager'">
        <v-row v-for="(vendor, index) in salesManagersDateWise" :key="vendor">
            <v-col cols="4" :class="{ 'pt-7': index === 0 }" class="text-left">
              <span v-if="index === 0" style="font-weight: 600;">Add Vendors</span>
            </v-col>
            <v-col cols="2">
              <v-menu v-model="vendor.date_model" :close-on-content-click="false" v-model:return-value="vendor.visitDate" transition="scale-transition" offset-y  min-width="290px">
                <template v-slot:activator="{ props }">
                    <v-text-field variant="outlined" color="primary" v-model="vendor.formatted_visit_date3" label="Visit Date" prepend-inner-icon="mdi-calendar" readonly v-bind="props" ></v-text-field>
                </template>
                <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                  <v-date-picker  :min="from_date" :max="to_date"  v-model="vendor.visitDate" hide-header color="primary" scrollable  min-width="200" max-width="300">
                  </v-date-picker>
                  <v-card-action class="d-flex justify-end pb-3">
                    <v-spacer></v-spacer>
                    <v-btn variant="text" color="primary" class="text-none" @click="vendor.date_model = false">Cancel</v-btn>
                    <v-btn variant="text" color="primary" class="text-none"  @click="handleVendorSaveDate(vendor)">Ok</v-btn>
                  </v-card-action>
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="2">
              <v-autocomplete class="text-left" v-model="vendor.vendor" label="Type of Vendor" prepend-inner-icon="mdi-magnify" :items="['Dealer','Partner']" variant="outlined"/>
            </v-col>
            <v-col cols="2">
              <v-autocomplete class="text-left" v-model="vendor.customer_name" label="Customer Name" prepend-inner-icon="mdi-magnify" :items="customerDetails" variant="outlined"
               item-title="cutomer_name" @update:modelValue="updateVendorLocation(vendor)" return-object/>
            </v-col>
            <v-col cols="2" class="d-flex flex-column">
              <v-autocomplete v-model="vendor.location" label="Location" prepend-inner-icon="mdi-magnify" variant="outlined" :disabled="!vendor.customer_name"
              :items="vendor.list" item-title="address_detail" multiple  return-object chips  class="custom-height">
                <template v-slot:selection="data">
                  <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                      <v-chip
                        v-bind="props"
                        class="mr-2"
                        :key="data.item.id"
                        variant="outlined"
                      >
                        {{ data.item.address_detail }}
                      </v-chip>
                    </template>
                    <span>{{ data.item.address_detail }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
              <div>
                <span class="float-right">
                  <v-icon class="mr-2" color="primary" style="border: 1px solid; border-radius: 4px;" :disabled="snackbar.visible"  @click="addNewVendor(vendor)">mdi-plus</v-icon>
                  <v-icon class="mr-2" color="error" style="border: 1px solid; border-radius: 4px;" @click="DeleteVendor(index)" :disabled="salesManagersDateWise.length == 1">mdi-delete-outline</v-icon>
                </span>
              </div>
            </v-col>
          </v-row>
      </div>
        <v-row>
          <v-col cols="12" sm="12" class="p-0">
            <v-card-actions class="float-right">
              <v-btn color="primary" variant="flat" class="text-none" :disabled="checkDisabilityCreatePlan"  size="x-large" @click="dateWiseContinue">Create Plan</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- create tour plan ends -->
    <!--data table  -->
    <v-layout column v-if="(active_tab !== 'Create' || tour_action !== 'create_tour_plan')  && active_tab !== 'Upcoming Visits' && active_tab !== 'NDC'">
      <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
        <v-data-table hover
          density="compact"
          :style="dataTableStyle"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="100%" 
          :loading="loading"
          :items-per-page="pageSize"
          return-object
          loading-text="Loading Data... Please wait"
          class="elevation-1 text-left" >
           <template v-for="(header, index) in headers" :key="index" v-slot:[`item.${header.key}`]="{ item }" >
            <span>
              <span v-if="item[header.key] !== null && item[header.key] !== ''">{{ item[header.key] }}</span>
              <span v-else>-</span>
            </span>
          </template>
          <template #[`item.tour_id`]="{ item }" v-if="active_tab !== 'Upcoming Visits'">
            <a @click="itemDetailPopup(item)" style="color: #1976d2; cursor: pointer">
              <u> {{ item.tour_id }}</u>
            </a>
          </template>
          
          <template #[`item.tour_period`]="{ item }">
            <v-span v-if="item.tour_period">
              {{    item.tour_period.slice(0,10).split('-').reverse().join('/') }} - {{ item.tour_period.slice(14).split('-').reverse().join('/') }}
            </v-span>
            <v-span v-else>
              '-'
            </v-span>
          </template>
          <template #[`item.status`]="{ item }">
            {{ getStatusMessage(item.status) }}
          </template>
          <template #[`item.user_name`]="{ item }">
            {{ item.user_name }} ({{ item.sales_manager_id }})
          </template>
          <template #bottom></template>
        </v-data-table> 
        <template #[`item.status`] = "{ item }">
          <v-span v-if="item.status == 'reject'">Reject</v-span>
          <v-span v-else-if="item.status == 'pending_approval'">Pending Approval</v-span>
        </template>
      </v-col>
    </v-layout>
    <!-- data for approval tour plan -->
    <v-layout column v-if="active_tab === 'Own Approved Tour Plan'">
      <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
        <tbody>
          <tr>
            <td :colspan="2" style="font-size: 14px;"><v-span class="ml-4"><b>{{ groupedTableData.length > 0 ? groupedTableData[0].stage : '' }}</b></v-span></td>
          </tr>
        </tbody>
        <v-data-table hover
          density="compact"
          :style="dataTableStyle"
          :search="search"
          v-model="selectedApprove"
          disable-pagination
          :hide-default-footer="true"
          :headers="current_headers"
          :items="groupedTableData"
          fixed-header
          height="100%" 
          :loading="loading"
          :items-per-page="pageSize"
          return-object
          loading-text="Loading Data... Please wait"
          class="elevation-1" >
          <template v-slot:body="{ items }">
            <!-- <tbody class="w-100"> -->
              <template v-for="(group, index) in items">
                <tr :key="index" class="v-data-table-group__subtitle" v-if="index != 0">
                  <td :colspan="current_headers.length" ><b>{{ group.stage }}</b></td>
                </tr>
                <tr v-for="(item, itemIndex) in group.items" :key="itemIndex" class="text-left">
                  <td>
                    <a @click="itemDetailPopup(item)" style="color: #1976d2; cursor: pointer;">
                      <u> {{ item.tour_id }}</u>
                    </a>
                  </td>
                  <td>
                    <v-span v-if="item.tour_period">
                      {{    item.tour_period.slice(0,10).split('-').reverse().join('/') }} - {{ item.tour_period.slice(14).split('-').reverse().join('/') }}
                    </v-span>
                    <v-span v-else>
                      '-'
                    </v-span>
                  </td>
                  <td>{{ item.stage }}</td>
                </tr>
              </template>
          <!-- </tbody> -->
          </template>
          <template #bottom></template>
        </v-data-table> 
      </v-col>
    </v-layout>
    <!-- upcoming visit data -->
    <v-card v-if="active_tab === 'Upcoming Visits'" class="v-card-100 mt-0">
      <v-row>
        <v-col v-if="upcoming_visits.id == 'today' || upcoming_visits.id == 'all'">
          <div class="upcoming_date_css py-4">Date: {{ DateFormat(new Date()).split('-').reverse().join('/') }} (Today)</div>
          <div v-for="(item,index) in todays_visits" :key="index">
            <v-row class="card_color pa-2 ma-2">
              <v-col cols="6" class="d-flex flex-column text-left">
                <span class="upcoming_visit_heading mb-1">Tour Plan ID</span>
                <a @click="itemDetailPopup(item)" style="color: #1976d2; cursor: pointer">
                  <u> {{ item.tour_tag }}</u>
                </a>
              </v-col>
              <v-col cols="6" class="d-flex flex-column text-left">
                <span class="upcoming_visit_heading mb-1">Service Manager Name</span>
                <span class="upcoming_visit_value">{{ item.name }}</span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col v-if="upcoming_visits.id == 'tomorrow' || upcoming_visits.id == 'all'">
          <div class="upcoming_date_css py-4">Date: {{ DateFormat(new Date(new Date().setDate(new Date().getDate() + 1))).split('-').reverse().join('/') }} (Tomorrow)</div>
          <div v-for="(item,index) in tommarow_visits" :key="index">
            <v-row class="card_color pa-2 ma-2">
              <v-col cols="6" class="d-flex flex-column text-left">
                <span class="upcoming_visit_heading mb-1">Tour Plan ID</span>
                <a @click="itemDetailPopup(item)" style="color: #1976d2; cursor: pointer">
                  <u> {{ item.tour_tag }}</u>
                </a>
              </v-col>
              <v-col cols="6" class="d-flex flex-column text-left">
                <span class="upcoming_visit_heading mb-1">Service Manager Name</span>
                <span class="upcoming_visit_value">{{ item.name }}</span>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col v-if="upcoming_visits.id == 'day_after_tomorrow' || upcoming_visits.id == 'all'">
          <div class="upcoming_date_css py-4">Date: {{ DateFormat(new Date(new Date().setDate(new Date().getDate() + 2))).split('-').reverse().join('/') }} (Day After Tomorrow)</div>
          <div v-for="(item,index) in day_after_tomorrow_visits" :key="index">
            <v-row class="card_color pa-2 ma-2">
              <v-col cols="6" class="d-flex flex-column text-left">
                <span class="upcoming_visit_heading mb-1">Tour Plan ID</span>
                <a @click="itemDetailPopup(item)" style="color: #1976d2; cursor: pointer">
                  <u> {{ item.tour_tag }}</u>
                </a>
              </v-col>
              <v-col cols="6" class="d-flex flex-column text-left">
                <span class="upcoming_visit_heading mb-1">Service Manager Name</span>
                <span class="upcoming_visit_value">{{ item.name }}</span>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- upcoming visit data end-->
    <!-- ndv data table -->
    <v-layout column v-if="active_tab === 'NDC'">
      <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
        <v-row class="text-center">
          <v-col sm="12" lg="12" md="12">
            <span>Current Cycle: {{ currentCycle }}  </span>
          </v-col>
        </v-row>
        <v-data-table hover
          :style="dataTableStyle"
          density="compact"
          :search="search"
          show-select
          v-model="selected"
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="100%" 
          :loading="loading"
          :items-per-page="pageSize"
          return-object
          loading-text="Loading Data... Please wait"
          class="elevation-1" >
          <!-- <template #[`item.date`]="{ item }">
            <v-span>{{ item.date ? item.date : '-'}}</v-span>
          </template> -->
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'ndc'">
                <v-btn class="text-none" color="primary" :disabled="item.status === 'Not Initiated'" small variant="outlined" @click="pdfView(item)">View</v-btn>
              </span> 
              <span v-else-if="header.key == 'status'">
                <div>
                  <span v-if="item.status === 'Closed'">
                    {{ item.status }}
                    <span @click="remarksDetails(item)"><v-icon>mdi-message-text</v-icon> </span>
                  </span>
                  <span v-else>{{ item.status ? item.status === 'Pending' ? 'Initiated' : item.status : '-' }}</span>
                </div>             
              </span>
              <span v-else-if="header.key == 'location_id'">
                <v-tooltip location="bottom" text="item.location" v-if="item.location_id">
              <template v-slot:activator="{ props }">
                <a v-bind="props" style="color:#1976d2; text-decoration: underline;">
                  {{ item.location_id }}
                </a>
              </template>
              <div style="max-width: 700px; word-wrap: break-word;">{{ item.location }}</div>
            </v-tooltip>              
          </span> 

              <span v-else-if="header.key !== 'imags' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
        <span v-else>-</span>
      </template>
          <!-- <template #[`item.ndc`]="{ item }">
            <v-btn class="text-none" color="primary" :disabled="item.status === 'Not Initiated'" small variant="outlined" @click="pdfView(item)">View</v-btn>
          </template> -->
          <!-- <template #[`item.status`]="{ item }">
            <div>
              <span v-if="item.status === 'Closed'">
                {{ item.status }}
                <span @click="remarksDetails(item)"><v-icon>mdi-message-text</v-icon> </span>
              </span>
              <span v-else>{{ item.status ? item.status === 'Pending' ? 'Initiated' : item.status : '-' }}</span>
            </div>
          </template> -->
          <!-- <template #[`item.location_id`] = "{ item}">
            <v-tooltip location="bottom" text="item.location" v-if="item.location_id">
              <template v-slot:activator="{ props }">
                <a v-bind="props" style="color:#1976d2; text-decoration: underline;">
                  {{ item.location_id }}
                </a>
              </template>
              <div style="max-width: 700px; word-wrap: break-word;">{{ item.location }}</div>
            </v-tooltip>
            <span v-if="!item.location_id">-</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <!--data table end -->
    <!-- pagination -->
    <div v-if="(active_tab !== 'Create' || tour_action !== 'create_tour_plan') && active_tab !== 'Upcoming Visits'">
      <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-1 mb-0"
                />
    </div>
  </v-card>
</template>
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import Loading from 'vue-loading-overlay';
import _ from 'lodash';
// import 'vue-loading-overlay/dist/vue-loading.css';
import { securedAxiosInstance, plainAxiosInstance,IS_QA_SERVER,API_URL } from '@/backend/axios/index'
import DynamicHeader from "@/components/commoncomponents/DynamicHeader.vue";
export default {
  components: {
    HeaderComponent, Loading, DynamicHeader
  },
  data() {
    return {
      headerText: "Tour Plan",
      alert: false,
      alert_type: "success",
      alert_message: '',
      active_tab: "Create",
      tour_action: 'pending_apporval',
      // tabs content
      tabs1: [
        "Create",
        "Approval Requests",
        "Approved Tour Plans", 
        "Upcoming Visits",
        "History",
        "NDC"
      ],
      menu1: false,
      to_date: null,
      menu2: false,
      from_date: null,
      selectMethod : false,
      selectDetails: false,
      sales_manager: '',
      sales_manager_details : [],
      visitDate : false,
      visit_date : null,
      date_wise_manager: '',
      date_wise_manager_details : [],
      visitDate2 : false,
      visit_date2 : null,
      filterDetails: false,
      search_tag: '',
      selected: [],
      table_data: [],
      headers:[
        { title: "Tag ID", align: "start", sortable: false, key:"request_id"},
        { title: "Article ID", key: "created_at" },
      ],
      search: '',
      loading : false,
      selectedApprove: [],
      current_headers: [
        { title: "kjl", align: "start", sortable: false, key:"request_id"},
        { title: "asf", key: "created_at" },
      ],
      current_table_data: [],
      visit_Date: [],
      visit: '',
      approveRemarkPopup: false,
      successPopup: false,
      SuccessMessage :'',
      add_remarks: '',
      rejectRemarkPopup: false,
      reject_remarks: '',
      page : 1 ,
      totalPages : 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      errorMessage: '',
      errorMessagePopup: false,
      select_stage: '',
      stage_items: [
        {
          "name":"Current",
          "id": "Current"
        },
        {
          "name":"Upcoming",
          "id": "Upcoming"
        }
      ],
      upcoming_visits: { "name":"All", "id": "all" },
      upcoming_visits_items : [
        {
          "name":"All",
          "id": "all"
        },
        {
          "name":"Today",
          "id": "today"
        },
        {
          "name":"Tomorrow",
          "id": "tomorrow"
        },
        {
          "name":"Day After Tomorrow",
          "id": "day_after_tomorrow"
        }
      ],
      visitDateInfoPopup: false,
      info_headers: [],
      headers_sales_wise : [
        { title: "Date", align: "start", sortable: false, key:"visit_date"},
        { title: "Customer Name", key: "manager_customer_name" }
      ],
      headers_date_wise : [
        { title: "Customer Name", key: "customer_name" },
        { title: "Service Manager Name", key: "manager_name" }
      ],
      upcoming_headers : [
        { title: "Vendor Name", key: "customer_name" },
        { title: "Location", key: "location" }
      ],
      info_table_data: [],
      error: '',
      salesManagers: [],
      salesManagersDateWise : [],
      tab_index : 0,
      todays_visits: [],
      tommarow_visits: [],
      day_after_tomorrow_visits: [],
      filterFromDate: false,
      filterToDate : false,
      filter_from_date : null,
      filter_to_date : null,
      month_wise : null,
      service_manager_id : '',
      year_wise : null,
      month_wise_items : [],
      year_wise_items : [
        {
          "name":"2021",
          "id": "2021"
        },
        {
          "name":"2022",
          "id": "2022"
        },
        {
          "name":"2023",
          "id": "2023"
        },
        {
          "name":"2024",
          "id": "2024"
        },
        {
          "name":"2025",
          "id": "2025"
        },
      ],
      tab_index: 0,
      managers_name: '',
      managers_name_items:[],
      managers_name_items2 : [],
      manager_name_id_mapping : [],
      editAction : '', 
      isLoading : false,
      fullPage : true,
      primary_code: "#0275d8",
      total_planned_manager_count :'',
      total_sales_manager_count : '',
      deleteConfirmationPopup : false,
      currentUser: {},
      dealer_filter : null,
      dealer_filter_items: '',
      sales_manager_filter : null,
      sales_manager_filter_items: '',
      isDatePickerFromDate: new Date(),
      isDatePickerToDate: new Date(),
      isDatePickerFromDateFilter: new Date(),
      isDatePickerToDateFilter : new Date(),
      current_cycle: null,
      current_cycle_items: [],
      selected_designation: [],
      pdfPopup: false,
      remarksPopup: false,
      remarksDetailsPopup : false,
      currentCycle: '',
      message : '',
      pdfView_url : '',
      pdfdownload_url : '',
      pdfs: [],
      popupVisible: false,
      pdfViewerUrl:'',
      shouldShowArrows: false,
      allowDates:'',
      role: '',
      customerDetails : [],
      snackbar: false,
      complete_headers: [],
      beforeHeaders: [],
      is_filtered: false,
      select_field_items: [
        {
          "name":"User Name",
          "id": "username"
        },
        {
          "name":"Dealer",
          "id": "dealer"
        }
      ],
      select_field: 'username',
      snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          timeout: 3000,
          title: null,
          visible: false
        },
      organization_name: '',
    }
  },
  async created() {
    // this.loadData('Create');
    this.organization_name = this.$store.state.organization_name;
    this.role = this.$store.state.currentUser.roles[0];
    this.editAction = this.$store.state.tour_action
    if (this.editAction !== "Create Tour Plan" && this.role != 'admin'){
      const tabName = this.$route.query.tab;
      if(this.editAction == 'Create' || tabName == 'Create'){
        this.tab_index = 0;
        this.loadData("Create")
      } else if(this.editAction == 'Approval Requests' || tabName == 'Approval_Requests'){
        this.tab_index = 1;
        this.loadData('Approval Requests')
      } else if(this.editAction == 'Approved Tour Plans' || tabName == 'Approved_Tour_Plans'){
        this.loadData('Approved Tour Plans')
        this.tab_index = 2;
      } else if(this.editAction == 'Upcoming Visits' || tabName == 'Upcoming_Visits'){
        this.loadData('Upcoming Visits')
        this.tab_index = 3;
      } else if(this.editAction == 'History' || tabName == 'History'){
        this.loadData('History')
        this.tab_index = 4;
      } else {
        this.tab_index = 0;
        this.loadData("Create")
      }
    } else if(this.editAction === "Create Tour Plan") {
      this.tour_action = 'create_tour_plan'
      this.from_date = this.$store.state.from_Date
      this.to_date = this.$store.state.to_date
      this.selectMethod = this.$store.state.method;
      this.selectDetails = this.$store.state.select_details;
      if(this.$store.state.currentUser.roles.includes('area_service_manager'))
        this.getDropDownData()
      else  this.getSalesManagers();
      if(this.selectDetails == 'sales_manager_wise'){
        this.salesManagers = this.$store.state.original_sales_manager
        console.log(this.salesManagers)
      } else {
        this.salesManagersDateWise = this.$store.state.original_sales_manager
        console.log(this.salesManagersDateWise)
      }
    }
    this.select_stage = "Current"
    this.upcoming_visits = { "name":"All", "id": "all" }
    if(this.role === 'admin'){
      this.tab_index = 2;
      this.active_tab = 'Approved Tour Plans'
      this.loadData('Approved Tour Plans')
    }
  },
  computed: {
    formattedFromDate(){
      if (this.from_date) {
        const date = new Date(this.from_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
      return '';
    },
    formattedFromDatefilter(){
      if (this.filter_from_date) {
        const date = new Date(this.filter_from_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
      return '';
    },
    formattedToDatefilter(){
      if (this.filter_to_date) {
        const date = new Date(this.filter_to_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
      return '';
    },
    
    formattedToDate(){
      if (this.to_date) {
        const date = new Date(this.to_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
      return '';
    },
    formattedVisitDate(){
      if (this.manager.visit_date) {
        const date = new Date(this.manager.visit_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    },
    formattedVisitDate2(){
      if (this.visit_date2) {
        const date = new Date(this.visit_date2);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    },
    groupedTableData() {
      const groupedData = {};
      this.current_table_data.forEach(item => {
        if (!groupedData[item.stage]) {
          groupedData[item.stage] = [];
        }
        groupedData[item.stage].push(item);
      });
      return Object.keys(groupedData).map(stage => ({
        stage,
        items: groupedData[stage]
      }));
    },
    minDate(){
      const currentDate = new Date();
      let startOfNextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
      startOfNextMonth.setHours(23, 59, 59, 999);
      return startOfNextMonth.toISOString().substr(0, 10);
    },
    tommarow_date(){
      const today_date = new Date();
      today_date.setDate(today_date.getDate()+1)
      return today_date.toISOString().substr(0, 10)
    },
    nextMonthEnd(){
      let cur_date = new Date();
      let cur_month = cur_date.getMonth()+1;
      let cur_year = cur_date.getFullYear();
      if (cur_month > 10) { 
        cur_month = 0;
        cur_year++;
      }
      let secondMonthFirstDay = new Date(cur_year, cur_month + 1, 1);
      let lastDateOfNextMonth = new Date(secondMonthFirstDay - 1);
      return lastDateOfNextMonth.toISOString().substr(0, 10);
    },
    maxDate() {
      const currentDate = new Date();
      let endOfNextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0);
      endOfNextMonth.setHours(23, 59, 59, 999);
      return endOfNextMonth.toISOString().substr(0, 10);
    },
    dialogMaxWidth() {
      const tabWidths = {
        'History': '600px',
        'NDC': '1080px',
        'Approved Tour Plans': '1080px',
      };

      return tabWidths[this.active_tab] || '600px';
    },
    min_available_date(){
      var f_date = new Date(this.from_date)
      var t_date = new Date(this.to_date)
      f_date.setHours(0, 0, 0, 0)
      t_date.setHours(0, 0, 0, 0)
      // if(new Date(f_date.getTime()+13*24*60*60*1000)<=t_date){
      //   const date = new Date(f_date.getTime()+13*24*60*60*1000)
      //   const dd = String(date.getDate()).padStart(2, '0');
      //   const mm = String(date.getMonth() + 1).padStart(2, '0');
      //   const yyyy = date.getFullYear();
      //   return `${yyyy}-${mm}-${dd}`;
      // }
      // else 
      return this.to_date
    },
    dropdownTabStyle() {
      return {
        textTransform: 'none',
        width: 'auto',
        padding: '0 12px'
      };
    },
    dropdownTabStyleTab(){
      return {
        textTransform: 'none',
        width: 'auto',
        padding: '10px 0px'
      };
    },
    dataTableStyle() {
      if(this.active_tab === 'NDC'){
        return { height: 'calc(var(--vh, 1vh) * 100 - 363px) !important' }
      }else{
        return {height: 'calc(var(--vh, 1vh) * 100 - 338px) !important'};
      }
      
    },
    checkDisabilityCreatePlan(){
      return this.role == 'area_service_manager' && this.salesManagersDateWise.some(item => !item.visitDate || !item.vendor || !item.customer_name || !item.location)
    }
  },
  watch: {
    'manager.visit_date'(newDate) {
      if (newDate) {
        const parts = newDate.split('/');
        this.manager.formattedVisitDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
      } else {
        this.manager.formattedVisitDate = '';
      }
    },
    'manager.visitDates': {
      handler(newVal) {
        newVal.forEach(visitDate => {
          this.updateFormattedDate(visitDate);
        });
      },
      deep: true
    },
    tab_index() {
      this.checkTabOverflow();
    }
  },
  methods: {
    updateHeaders(headers){
          this.beforeHeaders = headers.map(header => header)
          this.headers = headers
        },
    checkTabOverflow() {
      this.$nextTick(() => {
        const tabsContainer = this.$refs.tabsContainer;
        if (tabsContainer) {
          const tabsWrapper = tabsContainer.$el.querySelector('.v-tabs__wrapper');
          const tabsContent = tabsContainer.$el.querySelector('.v-tabs__div');
          if (tabsWrapper && tabsContent) {
            this.shouldShowArrows = tabsContent.scrollWidth > tabsWrapper.clientWidth;
          }
        }
      });
    },
    getTabStyle(tab) {
      const width = this.calculateTabWidth(tab) + 'px';
      return {
        textTransform: 'none',
        width,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '0 12px'
      };
    },
    calculateTabWidth(tab) {
      const baseWidth = 120; // Minimum width for tabs
      const charWidth = 10; // Width per character
      const padding = 24; // Additional padding
      return Math.max(baseWidth, tab.length * charWidth + padding);
    },
    filteredManagers(manager, visitIndex) {
      const selectedManagers = manager.manager_list
        .filter((_, idx) => idx !== visitIndex)
        .map(item => item.manager_name);
      return this.managers_name_items2.filter(item => !selectedManagers.includes(item.sales_manager));
    },
    handleCancel(visitDate,visitIndex,manager){
      visitDate.date = null;
      visitDate.showDialog = false;
      visitDate.dateFormatted = null;
      manager.visitDates.splice(visitIndex+1,visitDate.count);
    },
    handleCancel2(manager){
      manager.visit_date2 = null;
      manager.visitDate2 = false;
    },
    updateFormattedDate(visitDate) {
      const date = new Date(visitDate.date);
      const t_date = new Date()
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      visitDate.dateFormatted = `${day}/${month}/${year}`;
      if(date.getMonth() >= t_date.getMonth()+1){
        this.salesManagers.forEach(manager =>{
          manager.visitDates.forEach((m_date,index) =>{
            if (m_date == visitDate){
              var f_date = new Date(visitDate.date)
              var t_date = new Date(this.to_date)
              f_date.setHours(0, 0, 0, 0)
              t_date.setHours(0, 0, 0, 0)
              var ind = index
              manager.visitDates.splice(index+1,m_date.count)
              // while(new Date(f_date.getTime()+14*24*60*60*1000)<=t_date){
              //   f_date = new Date(f_date.getTime()+14*24*60*60*1000)
              //   const dd = String(f_date.getDate()).padStart(2, '0');
              //   const mm = String(f_date.getMonth() + 1).padStart(2, '0');
              //   const yyyy = f_date.getFullYear();
              //   ind+=1
              //   manager.visitDates.splice(ind,0,{"date":`${yyyy}-${mm}-${dd}`, "showDialog":false, "dateFormatted":`${dd}/${mm}/${yyyy}`, disable : true,count : 0})
              // }
              m_date.count = ind-index
            }
          })
        })
      }
    },
    updateFormattedDateVisit(manager){
      const date = new Date(manager.visit_date2);
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      manager.formatted_visit_date2 = `${dd}/${mm}/${yyyy}`;
    },
    updateFormattedDateVisit1(vendor) {
        if (vendor.visitDate) {
          const date = new Date(vendor.visitDate);
          const dd = String(date.getDate()).padStart(2, '0');
          const mm = String(date.getMonth() + 1).padStart(2, '0');
          const yyyy = date.getFullYear();
          vendor.formatted_visit_date3 = `${dd}/${mm}/${yyyy}`; 
        } else {
          vendor.formatted_visit_date3 = '';
        }
      },
      handleCancel2(vendor) {
        vendor.date_model = false; 
      },
      createTourPlan() {
        this.to_date = this.maxDate
        this.from_date = this.minDate
        this.tour_action = 'create_tour_plan'
      },
    loadData(tab, type, tab_action) {
      this.active_tab = tab;
      if (type === 'subtab_clicked1') {
        this.shouldShowArrows = true;
      } else if (type === 'subtab_clicked2') {
        this.shouldShowArrows = true;
      } 
      if(tab_action){
        this.search_tag = ''
        // this.from_date = ''
        // this.to_date = ''
        this.filter_from_date = ''
        this.filter_to_date = ''
        this.selected = []
        this.table_data = []
        this.error = ''
        this.selectedApprove= []
        if(tab_action){
          var tabName = tab.replace(/\s/g,'_');
          tabName = tabName.replace(/&/g,'')
          this.$router.push({ name : 'tourVisit', query : { tab : tabName }});
        }
      }
      if(tab == 'Create'){
          (this.headers = [
            { title: "Tour ID", align: "start", sortable: false, key:"tour_id"},
            { title: "Tour Period", key: "tour_period" },
            { title: "Status", key: "status" },
            { title: "Remarks", key: "remarks" },
          ]);
          this.selectDetails = ''
          this.tour_action = 'pending_apporval'
          this.pendingApprovalList ();
        }
        if(tab == 'Approval Requests'){
          (this.headers = [
            { title: "Tour Plan ID", key: "tour_id" },
            { title: "User Name", key: "user_name" },
            { title: "Designation", key: "designation" },
            { title: "Branch", key: "branch" },
            { title: "Tour Period", key: "tour_period" },
          ]);
          this.approvalRequest()
        }
        if(tab == 'Approved Tour Plans'){
          (this.headers = [
            { title: "Tour Plan ID", align: "start", sortable: false, key:"tour_id"},
            { title: "User Name", key: "user_name" },
            { title: "Designation", key: "designation" },
            { title: "Tour Period", key: "tour_period",sortable: false },
            { title: "Stage", key: "stage", sortable: false },
          ]);
          this.changeStage()
        }
        if(tab == 'History'){
          (this.headers = [
            { title: "Tour Plan ID", key: "tour_id" },
            { title: "User Name", key: "user_name" },
            { title: "Designation", key: "designation" },
            { title: "Month", key: "month" }
          ]);
          this.SalesManagerApprovalPlanHistory()
        }
        if(tab == 'Upcoming Visits'){
          this.dateSelect()

        }
        if(tab == 'NDC'){
          (this.headers = [
            { title: "User Name", key: "" },
            { title: "Dealer", align: "start", sortable: false, key:""},
            { title: "Status", key: "" },
            { title: "NDC", key: "" },
          ]);
          // this.headers = [];
          this.getNdc();
          this.getFilterData();
          this.select_field = 'username'
        }       
      this.selectMethod = false
      if(this.is_filter === false){
           this.complete_headers = this.headers.map(item => item)
           this.headers = this.headers.map(item => item)
          }else {
            this.complete_headers = this.headers.map(item => item)            
            this.headers = this.beforeHeaders.length > 0 ? this.beforeHeaders : this.headers.map(item => item)
          }
    },
    pendingApprovalList (){
      const params = {
          search_text: this.search_tag,
          status: "pending_approval",
          page: this.page,
          per_page: this.pageSize
        };
        this.loading = true;
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.table_data = response.data['fta/tour_plan/tours']
            .map(item =>({
              ...item,
              status: item.status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
              }))
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
            this.loading = false;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.showAlert("error", error.response.data.message);
        });
    },
    approvalRequest(){
      const params = {
          search_text: this.search_tag,
          status: "approval_requests",
          page: this.page,
          per_page: this.pageSize
        };
        this.loading = true;
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.table_data = response.data['fta/tour_plan/tours'];
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
            this.loading = false;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.showAlert("error", error.response.data.message);
        });
    },
    approvalTourPlan(){
      const params = {
        search_text: this.search_tag,
        status: "own_approved_tour_plans",
        page: this.page,
        per_page: this.pageSize
      };
      this.loading = true
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/own_approved_tour_plans', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.current_table_data = response.data['fta/tour_plan/tours']
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
            this.loading = false;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.showAlert("error", error.response.data.message);
        });
      this.loading = false;
    },
    changeStage(){
      this.salesManagerApprove()
      this.loading = true
    },
    salesManagerApprove(){
      const params = {
        search_text: this.search_tag,
        status: "sales_manager_approved_tour_plans",
        page: this.page,
        per_page: this.pageSize
      };
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/sales_manager_approved_tour_plans', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.table_data = response.data['fta/tour_plan/tours'];
            // this.table_data = response.data['fta/tour_plan/tours'].filter(item => item.stage === 'Current');
            // if (this.select_stage.name === "Current") {
            //   this.table_data = response.data['fta/tour_plan/tours'].filter(item => item.stage === 'Current');
            //   this.loading = false
            // } else if (this.select_stage.name === "Upcoming") {
            //   this.table_data = response.data['fta/tour_plan/tours'].filter(item => item.stage === 'Upcoming');
            //   this.loading = false
            // }
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
            this.loading = false;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.showAlert("error", error.response.data.message);
        });
    },
    ownApprovalTourPlanHistory(){
      const params = {
          search_text: this.search_tag,
          status: "own_approved_tour_plan_history",
          page: this.page,
          per_page: this.pageSize
        };
      this.loading = true;
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/own_approved_tour_plan_history', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.table_data = response.data['fta/tour_plan/tours'];
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
            this.loading = false
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.showAlert("error", error.response.data.message);
        });
    },
    SalesManagerApprovalPlanHistory(){
      const params = {
          search_text: this.search_tag,
          status: "sales_manager_approved_tour_plan_history",
          page: this.page,
          per_page: this.pageSize
        };
      this.loading = true;
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/sales_manager_approved_tour_plan_history', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.table_data = response.data['fta/tour_plan/tours'];
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.month_wise_items = this.table_data.map(x => x.month)
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.showAlert("error", error.response.data.message);
        });
    },
    dateSelect() {
      this.upcomingVisits()
    },
    upcomingVisits() {
      this.isloading = true;
      this.$httpSecured
        .get('/api/v1/warehouse/fta/tour_plan/tours/upcoming_visits')
        .then(response => {
          this.isloading = false;
          if (response.data) {
            this.sales_manager_details = response.data.upcoming_visits;
              let date = Object.keys(this.sales_manager_details)[0];
              this.todays_visits = this.sales_manager_details[date];
              date = Object.keys(this.sales_manager_details)[1];
              this.tommarow_visits = this.sales_manager_details[date];
              date = Object.keys(this.sales_manager_details)[2];
              this.day_after_tomorrow_visits = this.sales_manager_details[date];
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.isloading = false;
          this.showAlert("error", error.response.data.message);
        });
    },
    getNdc(){
      const requestBody = {
        search_text: this.search_tag,
        search_type: this.select_field,
        page: this.page,
        per_page: this.pageSize
      };
      this.loading = true;
      this.$httpSecured.get('/api/v1/warehouse/fta/tasks/visit_task/get_ndc_list', { params: requestBody })
        .then(response => {
          if (response.data.ndc_list) {
            // this.table_data = response.data.ndc_list;
            this.generateHeaders(response.data.ndc_list);
            this.currentCycle = response.data.current_cycle_list.display;
            this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.showAlert("error", error?.response?.data?.message);
        });
    },
    extractSubManagersTable(managers, level, result) {
      managers.forEach(manager => {
        var t_result = _.cloneDeep(result)
        t_result[0][`s_${manager.level}`] = manager.manager_name;
        if (manager.ndc_visit_task && manager.ndc_visit_task.length > 0) {
          manager.ndc_visit_task.forEach((task,index) => {
            var temp = _.cloneDeep(t_result[0]);
            temp.dealer = task.customer_name;
            temp.date = task.ndc_visit_task_date
            temp.status= task.status
            temp.remarks = task.remarks
            temp.task_id = task.task_id
            temp.location_id = task.location_id
            temp.location = task.location
            const len = this.table_data.length
            temp.id = len ? this.table_data[len-1].id +1 : 0
            this.table_data.push(temp)
          });
        }

        if (manager.sub_sales_managers && manager.sub_sales_managers.length > 0) {
          this.extractSubManagersTable(manager.sub_sales_managers, level + 1, t_result);
        }
      });
    },
    generateHeaders(data) {     
      if(data.length == 0){
        // this.headers = []
        return;
      }
      this.table_data = []
      this.headers = []
      const level = this.role === 'admin' ? data[1].level : data[0].level;
      for(let i=level;i>0;i--){
        this.headers.push({title : `User Name`,key : `s_${i}`,sortable : false})
        // this.headers.push({title : `S ${i}`,key : `s_${i}`,sortable : false})
      }
      this.headers.push({title : 'Dealer', key : 'dealer',sortable : false})
      this.headers.push({title : 'Location', key : 'location_id',sortable : false})
      this.headers.push({title : 'Status', key : 'status',sortable : false})
      this.headers.push({title : 'NDC', key : 'ndc',sortable : false})
      var t_data = [{}]
      this.extractSubManagersTable(data,1,t_data)
      this.updateTableData();
    },
    updateTableData(){
      let temp_data = [];
      this.table_data.forEach((item,index)=>{
        let prossed_entry = {}
        for(var i=0;i<this.headers.length-2;i++){
          prossed_entry[this.headers[i].key] = item[this.headers[i].key]
          // if(index == 0 || (item[this.headers[i].key] != this.table_data[index-1][this.headers[i].key]) || (i!=0 && prossed_entry[this.headers[i-1].key] != ''))
          //   prossed_entry[this.headers[i].key] = item[this.headers[i].key]
          // else prossed_entry[this.headers[i].key] = ''
        }
        prossed_entry.dealer = item.dealer
        prossed_entry.status = item.status
        prossed_entry.id = item.id
        prossed_entry.task_id = item.task_id
        prossed_entry.remarks = item.remarks
        prossed_entry.location_id = item.location_id
        prossed_entry.location = item.location
        if (item.date) {
          const date = new Date(item.date);
          const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
          prossed_entry.date = formattedDate;
        } else {
          prossed_entry.date = '-';
        }
        temp_data.push(prossed_entry)
      })
      this.table_data = temp_data
    },
    getFilterData(){
      this.$httpSecured.get('/api/v1/warehouse/fta/tasks/visit_task/get_sales_managers_list')
        .then(response => {
          if (response.data) {
            this.sales_manager_filter_items = response.data.managers
            this.dealer_filter_items = response.data.dealers
            this.current_cycle_items = response.data.cycle_list
            // this.loading = false
          } else {
            this.showAlert("error", "No Data Found");
            // this.loading = false;
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.showAlert("error", error.response.data.message);
        });
    },
    confirmDate(){
      if(new Date(this.to_date) < new Date(this.from_date)){
        this.error = 'Please ensure the To Date is after the From Date.'
        return;
      }
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/check_tour_dates', {
        "tour_start_date": this.from_date,
        "tour_end_date": this.to_date,
      },)
        .then(response => {
          if (response.data) {
            this.selectMethod = true
            this.selectDetails = 'date_wise'
            this.editAction = ''
            if(this.$store.state.currentUser.roles.includes('area_service_manager'))
              this.getDropDownData()
            else 
              this.getSalesManagers()
            this.error = ''
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.error = error.response.data.message
        });
    },
    addNewVendor(){
      this.salesManagersDateWise.push({ 'visitDate' : new Date(this.from_date), 'vendor' : 'Dealer', 'customer_name' : null, 'location': null , 'date_model' : false, list: [] })
    },
    addNewVendor(vendor){
      if(this.checkForDuplicate(vendor))
       return;
      this.salesManagersDateWise.push({ 'visitDate' : new Date(this.from_date), 'vendor' : 'Dealer', 'customer_name' : null, 'location': null , 'date_model' : false, list: [], 'formatted_visit_date3' : this.DateFormat(new Date(this.from_date)).split('-').reverse().join('/')})
    },
    DeleteVendor(index){
      this.salesManagersDateWise.splice(index,1)
    },
    updateVendorLocation(vendor){
      this.$httpSecured
      .get(`/api/v1/warehouse/fta/tour_plan/tours/get_customers_address?id=${vendor.customer_name.cutomer_id}&dealer_code=${vendor.customer_name.customer_dealer_code}`)
      .then((response)=>{
        const addresses = response.data.addresses;
        vendor.cutomer_id = vendor.customer_name.cutomer_id
          if (addresses.length === 1) {
            vendor.location = addresses;
            this.checkForDuplicate(vendor);
          }else{
            vendor.location = null;
          }
          vendor.list = addresses;
          })
      .catch(error => {
        this.$toast.error(error.response.data.message)
      })
    },
    combineDetails(vendor){
      return `${vendor.customer_name.cutomer_id}-${vendor.visitDate} - ${vendor.location.map(loc => loc.id).join(',')}`
    },
    checkForDuplicate(vendor) {
      const vendorDetails = this.combineDetails(vendor);
      const duplicate = this.salesManagersDateWise.some((v, index) => {
        return (
          v !== vendor &&
          this.combineDetails(v) == vendorDetails
        );
      });
        if (duplicate) {
          this.snackbar = true;
                  this.snackbar = {
                        color: "error",
                        icon: "warning",
                        mode: "multi-line",
                        position: "top",
                        timeout: 3000,
                        title: 'Warning',
                        text: "Duplicate tour plan with the same date, customer, and location. Please choose different details.",
                        visible: true
                      };
        }
        return duplicate
      },
    getDropDownData(){
      this.$httpSecured
      .get("api/v1/warehouse/fta/tour_plan/tours/get_customers")
      .then((response)=>{
        this.customerDetails = response.data.customers
        if(this.editAction != "Create Tour Plan")
        this.salesManagers = this.customerDetails.map(manager => ({
              sales_manager: `${manager.cutomer_name} (${manager.customer_dealer_code})`,
              // sales_manager: manager.sales_manager,
              sales_manager_plan : [],
              manager_id : manager.customer_dealer_code,
              cutomer_id : manager.cutomer_id,
              visitDates: [{
                date: null,
                showDialog: false,
                disable : false,
                count : 0,
              }]
            }));
          this.salesManagersDateWise = [
          { 'visitDate' : new Date(this.from_date), 'vendor' : 'Dealer', 'customer_name' : null, 'location': null , 'date_model' : false, list: [], 'formatted_visit_date3' : this.DateFormat(this.from_date).split('-').reverse().join('/')  }
        ]
      })
      .catch(error => {
        this.$toast.error(error.response.data.message)
      })
    },
    getSalesManagers() {
      this.$httpSecured
        .get(`/api/v1/warehouse/fta/tour_plan/tours/get_sales_managers?tour_start_date=${this.from_date}&tour_end_date=${this.to_date}`)
        .then(response => {
          if (response.data && response.data.sales_managers) {
            this.service_manager_id = response.data.sales_manager_id
            this.managers_name_items = response.data.sales_managers
            this.managers_name_items2 = [];
            this.managers_name_items.forEach(item => {
              let formattedItem = {
                sales_manager_id: item.sales_manager_id,
                sales_manager: `${item.sales_manager} (${item.sales_manager_id})`
              };
              this.managers_name_items2.push(formattedItem);
            });
            this.updateAddDealerData();
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.message);
        });
    },
    updateAddDealerData(){
      const manager_name_id_map = {};
      this.managers_name_items.forEach(manager => {
        manager_name_id_map[manager.sales_manager_id] = `${manager.sales_manager} (${manager.sales_manager_id})`;
        // manager_name_id_map[manager.sales_manager_id] = manager.sales_manager;
      });

      this.manager_name_id_mapping = manager_name_id_map
      if(this.editAction != 'Create Tour Plan' || (this.editAction == 'Create Tour Plan' && this.selectDetails != 'sales_manager_wise')){
        this.salesManagers = this.managers_name_items.map(manager => ({
          sales_manager: `${manager.sales_manager} (${manager.sales_manager_id})`,
          // sales_manager: manager.sales_manager,
          sales_manager_plan : manager.sales_manager_plan,
          manager_id : manager.sales_manager_id,
          cutomer_id: manager.cutomer_id,
          visitDates: [{
            date: null,
            showDialog: false,
            disable : false,
            count : 0,
          }]
        }));
      }
      if(this.editAction != 'Create Tour Plan' || (this.editAction == 'Create Tour Plan' && this.selectDetails != 'date_wise')){
        this.salesManagersDateWise = []
        const fromDate = new Date(this.from_date);
        const toDate = new Date(this.to_date);
        var sales_manager_plans = {}
        this.managers_name_items.forEach(manager=>{
          if(manager.sales_manager_plan.length)
          manager.sales_manager_plan.forEach(plan =>{
            if(!(plan.visit_date in sales_manager_plans))
              sales_manager_plans[plan.visit_date] = []
            else 
              sales_manager_plans[plan.visit_date].push({ customer_name : plan.manager_customer_name, manager_name : manager.sales_manager})
          })
        })
        for (let currentDate = new Date(fromDate); currentDate <= toDate; currentDate.setDate(currentDate.getDate() + 1)){
          const dd = String(currentDate.getDate()).padStart(2, '0');
          const mm = String(currentDate.getMonth() + 1).padStart(2, '0');
          const yyyy = currentDate.getFullYear();
          const min_available_date = new Date(this.min_available_date)
          var is_disabled = currentDate > min_available_date
          // if(currentDate > new Date(this.min_available_date))
          // if(currentDate.getDay() != 0)
            this.salesManagersDateWise.push({ 
              visitDate2 : false, 
              visit_date2 : new Date(`${yyyy}-${mm}-${dd}`),
              formatted_visit_date2: `${dd}/${mm}/${yyyy}`,
              manager_list : [ { manager_name : null}],
              sales_manager_plan : sales_manager_plans[`${yyyy}-${mm}-${dd}`] ? sales_manager_plans[`${yyyy}-${mm}-${dd}`] : [],
              disable : is_disabled
            })
        }
      }
    },
    addVisitDateField(manager) {
      manager.visitDates.push({ 
        date: null,
        showDialog: false
      });
    },
    availableManagers(manager_list, currentManager) {
      const selectedManagers = manager_list.map(manager => manager.manager_name);
      return this.managers_name_items2.filter(manager => 
        !selectedManagers.includes(manager.sales_manager_id) || manager.sales_manager_id === currentManager
      );
    },
    addMoreManager(item){
      if(!item.disable)
        item.manager_list.push({manager_name : null});
    },
    itemDetailPopup(item){
      const tourId = item.tour_id
      const itemID = this.active_tab == 'Upcoming Visits' ? item.tour_tag : item.id
      this.$store.commit("setLotIds", {
        lotIds: tourId,
        inventoryId:  itemID,
        action: this.active_tab == 'Create' ? 'Pending Approval' : this.active_tab
      });
      this.$router.push({ name: "visitingInfo" });
    },
    salesManagerDetails(item){
      const tourId = item.sales_manager_id
      const itemID = item.id
      this.$store.commit("setLotIds", {
        lotIds: tourId,
        inventoryId:  itemID,
        action: this.active_tab
      });
      this.$router.push({ name: "smDetails" });
    },
    deletePending(){
      this.deleteConfirmationPopup = true;
    },
    deletePendingApprovalItems(){
      const item_id = this.selected.map(item => item.id)
      this.$httpSecured.delete(`/api/v1/warehouse/fta/tour_plan/tours/${item_id}`)
        .then(response => {
          if (response.data) {
            this.SuccessMessage = response.data.message;
            this.successPopup = true;
            this.rejectRemarkPopup = false;
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", error.response.data.message);
          this.number = 0;
          this.loading = false;
          this.rejectRemarkPopup = false;
        });
    },
    closePopups(){
      this.successPopup = false
      this.approveRemarkPopup = false
      this.rejectRemarkPopup = false
      this.deleteConfirmationPopup = false
      this.loadData(this.active_tab)
      this.selected = []
    },
    // updateNextDateManager(index){
    //   for(var ind = index+14;ind<this.salesManagersDateWise.length;ind+=14)
    //     this.salesManagersDateWise[ind].manager_list = this.salesManagersDateWise[index].manager_list
    // },
    proceed(){
      const fromDate = this.from_date
      const toDate = this.to_date
      const dateManagerWise = this.selectDetails
      const managerDetails = []
      this.salesManagers.forEach(manager =>{
        manager.visitDates.forEach(m_date => {
          if(m_date.date)
            managerDetails.push({ salesManagerID : manager.manager_id, visit_date : m_date.date, sales_manager :  manager.sales_manager, cutomer_id: manager.cutomer_id})
         })
      })
      this.total_sales_manager_count = this.managers_name_items2.length
      this.total_planned_manager_count = 0
      this.salesManagers.forEach(item =>{
        this.total_planned_manager_count+=item.visitDates.some(date => date.date)
      })
      this.$store.commit("tourVisits", {
        from_Date : fromDate,
        to_date : toDate,
        select_details : dateManagerWise,
        manager_details : managerDetails,
        original_sales_manager : this.salesManagers,
        tour_action: "Create Tour Plan",
        total_sales_manager : this.total_sales_manager_count,
        total_planned_manager : this.total_planned_manager_count,
        service_manager_id : this.service_manager_id
      });
      this.$router.push({ name: "visitingInfo" });
    },
    dateWiseContinue() {
      const fromDate = this.from_date;
      const toDate = this.to_date;
      const dateManagerWise = this.selectDetails;

      if(this.role == 'area_service_manager'){
        // Calculate counts
        let managerDetails = [];
        console.log("salesManagersDateWise",this.salesManagersDateWise)
        this.salesManagersDateWise.forEach(item => {
            if (item.customer_name) {
              managerDetails.push({
                salesManagerID: item.customer_name.customer_dealer_code,
                visit_date: item.visitDate,
                sales_manager: `${item.customer_name.cutomer_name} (${item.customer_name.customer_dealer_code})`,
                cutomer_id: item.customer_name.cutomer_id
              });
            }
        });
        console.log("managerDetails",managerDetails)
        const vendor = this.salesManagersDateWise[this.salesManagersDateWise.length - 1]
        if(this.checkForDuplicate(vendor))
          return
        const uniqueSalesManagers = new Set(this.salesManagersDateWise.map(visit => visit.customer_name));
        this.total_planned_manager_count = uniqueSalesManagers.size;
        this.total_sales_manager_count = this.customerDetails.length;
        this.$store.commit("tourVisits", {
          from_Date: fromDate,
          to_date: toDate,
          select_details: dateManagerWise,
          manager_details: managerDetails,
          tour_action: "Create Tour Plan",
          original_sales_manager: this.salesManagersDateWise,
          total_sales_manager: this.total_sales_manager_count,
          total_planned_manager: this.total_planned_manager_count,
          service_manager_id : ''
        });
      } else {
        let managerDetails = [];
        this.salesManagersDateWise.forEach(item => {
          item.manager_list.forEach(s_manager => {
            if (s_manager.manager_name) {
              managerDetails.push({
                salesManagerID: s_manager.manager_name,
                visit_date: item.visit_date2,
                sales_manager: this.manager_name_id_mapping[s_manager.manager_name]
              });
            }
          });
        });


       // Generate list of visits
       let listOfVisit = [];
        this.salesManagersDateWise.forEach(item => {
          item.manager_list.forEach(manager => {
            if (manager.manager_name) {
              listOfVisit.push({ sales_manager: manager.manager_name });
            }
          });
        });

     // Calculate counts
        const uniqueSalesManagers = new Set(listOfVisit.map(visit => visit.sales_manager));
        this.total_planned_manager_count = uniqueSalesManagers.size;
        this.total_sales_manager_count = this.managers_name_items2.length;

         // Commit data to Vuex store
         this.$store.commit("tourVisits", {
          from_Date: fromDate,
          to_date: toDate,
          select_details: dateManagerWise,
          manager_details: managerDetails,
          tour_action: "Create Tour Plan",
          original_sales_manager: this.salesManagersDateWise,
          total_sales_manager: this.total_sales_manager_count,
          total_planned_manager: this.total_planned_manager_count,
          service_manager_id : this.service_manager_id
        });
      }

      // Navigate to the visitingInfo route
      this.$router.push({ name: "visitingInfo" });
    },
    filterListOfButtons() {
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
        this.filterDetails = true;
        this.month_wise = null
        this.year_wise = null
        this.sales_manager_filter = null
        this.dealer_filter = null
        this.current_cycle = null
        this.selected_designation = []
    },
    approveTourPlan(){
      this.approveRemarkPopup = true
    },
    rejectTourPlan(){
      this.rejectRemarkPopup = true
    },
    confirmApproveRequest(){
      const item_id = this.selected.map(item => item.id)
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/take_action', {
          "ids": item_id,
          "status": "approved",
          "remarks": this.add_remarks,
        },)
          .then(response => {
            if (response.data) {
              this.SuccessMessage = response.data.message;
              this.successPopup = true;
              this.rejectRemarkPopup = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.message);
            this.number = 0;
            this.loading = false;
            this.rejectRemarkPopup = false;
          });
    },
    confirmRejectRequest(){
      const item_id = this.selected.map(item => item.id)
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/take_action', {
          "ids": item_id,
          "status": "rejected",
          "remarks": this.reject_remarks,
        },)
          .then(response => {
            if (response.data) {
              this.SuccessMessage = response.data.message;
              this.successPopup = true;
              this.rejectRemarkPopup = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.message);
            this.number = 0;
            this.loading = false;
            this.rejectRemarkPopup = false;
          });
    },
    detailPopup(manager){
        // manager.visitDateInfoPopup = !manager.visitDateInfoPopup;
        if (manager.sales_manager_plan && manager.sales_manager_plan.length > 0) {
          this.info_table_data = manager.sales_manager_plan;
          this.info_headers = this.selectDetails === 'sales_manager_wise' ? this.headers_sales_wise : this.headers_date_wise
          this.visitDateInfoPopup = true;
        } else {
          this.info_table_data = []
          this.visitDateInfoPopup = true
        }
      this.loading = false
    },
    editTourPlan(){
      this.$router.push({ name: "editTourPlan" });
      this.$store.commit("setLotIds", {
        lotIds: this.selected[0].id,
        inventoryId:  this.selected[0].tour_id,
        action: this.active_tab
      });
      this.$store.commit("setFtaConfirmationInfo", {
        direction : false
      });  
    },
    getStatusMessage(status) {
      if (status === 'pending_approval') {
        return 'Pending Approval';
      } else if (status === 'rejected') {
        return 'Rejected';
      } else {
        return '-';
      }
    },
    applyFilterFun(){
      if (this.active_tab === 'Create') {
        const params = {
          status: "pending_approval",
          filter: {
            tour_start_date: this.filter_from_date,
            tour_end_date: this.filter_to_date
          },
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours', params)
          .then(response => {
            if (response.data && response.data['fta/tour_plan/tours']) {
              this.table_data = response.data['fta/tour_plan/tours'];
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.loading = false
              this.filterDetails = false
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.loading = false;
            this.errorMessage = error.response.data.message
          });
        }
      if (this.active_tab === 'Approval Requests'){
        const params = {
          status: "approval_requests",
          page: this.page,
          per_page: this.pageSize,
          filter: {
            tour_start_date: this.filter_from_date,
            tour_end_date: this.filter_to_date,
            designation: this.selected_designation.map(item => item.id)
          },
        };
      this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.table_data = response.data['fta/tour_plan/tours'];
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false
            this.filterDetails = false
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.errorMessage = error.response.data.message
        });
      }
      if (this.active_tab === 'Approved Tour Plans'){
        const params = {
          status: "sales_manager_approved_tour_plans",
          page: this.page,
          per_page: this.pageSize,
          filter: {
            tour_start_date: this.filter_from_date,
            tour_end_date: this.filter_to_date,
            designation: this.selected_designation.map(item => item.id)
          },
        };
        this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/sales_manager_approved_tour_plans', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.table_data = response.data['fta/tour_plan/tours'];
            // this.table_data = response.data['fta/tour_plan/tours'].filter(item => item.stage === 'Current');
            // if (this.select_stage.name === "Current") {
            //   this.table_data = response.data['fta/tour_plan/tours'].filter(item => item.stage === 'Current');
            //   this.loading = false
            // } else if (this.select_stage.name === "Upcoming") {
            //   this.table_data = response.data['fta/tour_plan/tours'].filter(item => item.stage === 'Upcoming');
            //   this.loading = false
            // }
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false
            this.filterDetails = false
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
        });
      }
      if (this.active_tab === 'History'){
        const params = {
          status: "sales_manager_approved_tour_plan_history",
          page: this.page,
          per_page: this.pageSize,
          filter: {},
        };
        if(this.month_wise)
          params.filter.month = this.month_wise
        if(this.year_wise)
          params.filter.year = this.year_wise.id
        if(this.selected_designation.length)
          params.filter.designation = this.selected_designation.map(item => item.id)
        this.$httpSecured.post('/api/v1/warehouse/fta/tour_plan/tours/sales_manager_approved_tour_plan_history', params)
        .then(response => {
          if (response.data && response.data['fta/tour_plan/tours']) {
            this.table_data = response.data['fta/tour_plan/tours'];
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false
            this.filterDetails = false
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.errorMessage = error.response.data.message
        });
      } 
      if (this.active_tab === 'NDC') {
        this.filterDetails = false;
        const requestBody = {
          page: this.page,
          per_page: this.pageSize,
          manager_name : this.sales_manager_filter,
          dealer : this.dealer_filter, 
          from : this.current_cycle ? this.current_cycle.from_date : null,
          to : this.current_cycle ? this.current_cycle.to_date : null
      };
      this.loading = true;
      this.$httpSecured.get('/api/v1/warehouse/fta/tasks/visit_task/get_ndc_list', { params: requestBody })
        .then(response => {
          if (response.data) {
            // this.table_data = response.data.ndc_list;
            this.generateHeaders(response.data.ndc_list);
            this.loading = false
            this.filterDetails = false
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
            this.number = 0;
          }
        }).catch(error => {
          this.number = 0;
          this.loading = false;
          this.errorMessagePopup = true;
          this.showAlert("error", error.response.data.message);
        });
      }
      
    },
    pdfView(item){
      this.pdfView_url = `${API_URL}/api/v1/warehouse/fta/tasks/visit_task/${item.task_id}/report.pdf?only_view=true`;
      // this.pdfdownload_url = `${API_URL}/api/v1/warehouse/fta/tasks/visit_task/${item.id}/report.pdf`
      this.pdfs=[  
        { imageUrl: 'http://digiartsplanet.com/wp-content/uploads/2018/10/2.png', url: this.pdfView_url }
        ]
      this.pdfdownload_url = item;
      this.pdfPopup = true
      this.showPdf(this.pdfView_url)
    },
    
    downloadPdf(){
      const url = `${API_URL}/api/v1/warehouse/fta/tasks/visit_task/${this.pdfdownload_url.task_id}/report.pdf`
      const link = document.createElement('a');
              link.href = url; 
              link.target = '_blank';
              link.download = 'report.pdf'; 
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
      // this.$httpSecured.get(`/api/v1/warehouse/fta/tasks/visit_task/${this.pdfdownload_url.id}/report.pdf`)
      // .then(response => {
      //    console.log(response)
      //   }).catch(error => {
      //     this.loading = false;
      //     this.showAlert("error", error.response.data.message);
      //   });
    },
    closeRequest(){
      this.remarksPopup = true
      this.reject_remarks = ''
    },
    remarksDetails(item){
      this.remarksDetailsPopup = true
      this.message = item.remarks
    },
    confirmClose(){
      this.$httpSecured
        .put(`/api/v1/warehouse/fta/tasks/visit_task/${this.selected[0].task_id}/close_ndc`,{ remarks : this.reject_remarks })
        .then(response => {
          if (response.data) {
            this.remarksPopup = false
            this.SuccessMessage = response.data.message;
            this.successPopup = true;
          } else {
            this.number = 0;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.$toast.error(error.response.data.error)
          this.assigneePopup = false;
          this.number = 0;
        });
    },
    // allowDates(date) {
    //   const dayOfWeek = new Date(date).getDay();
    //   return dayOfWeek !== 0;
    // },
    endDateOfMonth(date){
      let cur_date = new Date();
      let cur_month = cur_date.getMonth()+1;
      let cur_year = cur_date.getFullYear();
      if (cur_month > 10) { 
        cur_month = 0;
        cur_year++;
      }
      let firstDayOfSecondMonth = new Date(cur_year, cur_month + 1, 1);
      let lastDateOfNextMonth = new Date(firstDayOfSecondMonth - 1);
      let firstDayOfnextMonth = new Date(cur_year, cur_month, 1);
      let lastDateOfCurrMonth = new Date(firstDayOfnextMonth - 1);
      return lastDateOfNextMonth.toISOString().substr(0, 10) == date || lastDateOfCurrMonth.toISOString().substr(0, 10) == date;
    },
    startDateOfMonth(date){
      let cur_date = new Date();
      let cur_month = cur_date.getMonth()+1;
      let cur_year = cur_date.getFullYear();
      if (cur_month > 10) { 
        cur_month = 0;
        cur_year++;
      }
      let firstDayOfnextMonth = new Date(cur_year, cur_month, 1);
      firstDayOfnextMonth.setHours(23, 59, 59, 999)
      return new Date(date) <= firstDayOfnextMonth
    },
    allowDates1(date,index,visitIndex){
      let allowed = true
      this.salesManagers[index].visitDates.forEach((v_date,v_index)=>{
        if(v_index != visitIndex && v_date.date == date) allowed = false;
      })
      return allowed;
    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    alertTimeOut() {
      setTimeout(() => {this.alert = false;}, 3000);
    },
    handlePageSizeChange(size){
      this.pageSize = size;
        this.page = 1
        if (this.active_tab == 'Create') {
          this.pendingApprovalList ()
        } else if (this.active_tab == 'Approval Requests') {
          this.approvalRequest()
        }else if(this.active_tab == 'Approved Tour Plans'){
          this.changeStage()
        }else if(this.active_tab=='Upcoming Visits'){
          this.dateSelect()
        }else if(this.active_tab == 'History'){
          this.SalesManagerApprovalPlanHistory()
        }else if(this.active_tab == 'NDC'){
          this.getNdc();
        }
    },
    handlePageChange(value){
      this.page = value;
      if (this.active_tab == 'Create') {
          this.pendingApprovalList ()
        } else if (this.active_tab == 'Approval Requests') {
          this.approvalRequest()
        }else if(this.active_tab == 'Approved Tour Plans'){
          this.changeStage()
        }else if(this.active_tab=='Upcoming Visits'){
          this.dateSelect()
        }else if(this.active_tab == 'History'){
          this.SalesManagerApprovalPlanHistory()
        }else if(this.active_tab == 'NDC'){
          this.getNdc();
        }
    },
    eraseDate(visitDate,manager,index){
      visitDate.date = ""
      visitDate.dateFormatted = ""
      manager.visitDates.splice(index+1,visitDate.count)
    },
    deleteDate(item,index,visitDate){
      item.visitDates.splice(index,visitDate.count+1);
    },
    eraseManager(item){
      item.manager_name = null;
    },
    deleteManager(item,index){
      item.splice(index,1);
    },
    showPdf(pdfUrl) {
      // Use Google Docs Viewer to display PDF
      this.pdfViewerUrl = `https://docs.google.com/gview?url=${pdfUrl}&embedded=true`;
    },
    closePdfPopup(){
      this.pdfPopup = false
      this.pdfViewerUrl = ''
    },
    update_to_date(){
      const currentDate = new Date(this.from_date);
      let endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      endOfMonth.setHours(23, 59, 59, 999);
      this.to_date = endOfMonth.toISOString().substr(0, 10);
    },
    update_from_date(){
      const to__date = new Date(this.to_date)
      const from__date = new Date(this.from_date)
      if(to__date.getMonth() != from__date.getMonth())  
        this.from_date = null
    },
    formatted_filter_date(date) {
      return date;
    },
    handleSaveDate(dateType, dateState, selectDateState, type, endDate, calendarEndDate) {
      this[dateState] = this.formatted_filter_date(this[selectDateState]);
      if (type) {
        let selectedDate = new Date(this[selectDateState]);
        if (selectedDate.getTime() > new Date(this[endDate]).getTime()) {
          this[calendarEndDate] = this[selectDateState];
          this[endDate] = this[endDate] ? this.formatted_filter_date(this[selectDateState]) : '';
        }
      }
      this[dateType] = false;
    },
    handleVendorSaveDate(vendor){
      vendor.date_model = false
      if (vendor.visitDate) {
        const date = new Date(vendor.visitDate);
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        vendor.formatted_visit_date3 = `${dd}/${mm}/${yyyy}`;
      } else {
        vendor.formatted_visit_date3 = '';
      }
    },
    DateFormat(date){
        const new_date = new Date(date ? date : new Date());
        const dd = String(new_date.getDate()).padStart(2, '0');
        const mm = String(new_date.getMonth() + 1).padStart(2, '0');
        const yyyy = new_date.getFullYear();
        return `${yyyy}-${mm}-${dd}`
      },
      backToTourPlan(){
        this.tour_action = 'pending_apporval'
        this.editAction = ''
        this.selectMethod = false
        this.selectDetails = false
      }
  }
}
</script>
<style scoped>
  .select-card {
    border-top: 21px solid #E5E5E5
  }
  :deep(.radio-content .v-label) { 
    margin-bottom: 0px !important;
  }
  .v-dialog:has(.filter-repair){
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }
  .upcoming{
    border-bottom: 1px solid #e5e5e5;
  }
  .plan {
    color: #646262;
    font-size: 14px;
    font-weight: 500;
  }
  .error-message {
    color: red;
    font-size: 14px;
  }

  .error-border {
    border-color: red !important;
  }
  .item-selected{
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
  .v-slide-group__prev {
    display: none !important;
  }
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }
  .custom-control_outlined button {
      min-height: 52px;
      border-width: 1px;
      border-radius: 4px;
      border-color: rgba(0,0,0,.42);
      border-style: solid;

  }
  .custom-control_outlined button:focus {
    outline: none;
  }
  .v-dialog:has(.filter-style){
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }
  :deep(.custom-height .v-field__field) {
    /* padding: 0 12px !important; */
    height: 56px !important;
    overflow-y: scroll !important;
  }
 .filter_ui{
    margin-left: 10px !important;
    margin-top: 12px !important;
 }
  .router_link{
    position: relative;
    top: -32px;
    margin-left: 14px;
    font-size: 14px;
    width: 100%;
    text-align: left;
    margin-bottom: 4px;
  }
  .upcoming_date_css{
    font-size: 14px;
    font-weight: 600;
    color: #0C0C0C;
    line-height: 100%;
  }
  .upcoming_visit_heading{
    color: #938989;
    font-size: 14px;
    font-weight: 500;
    line-height: 100%;
  }
  .upcoming_visit_value{
    color: #0C0C0C;
    font-size: 14px;
    font-weight: 500;
    line-height: 100%;
  }
  .card_color{
    background-color: #FAFAFA;
  }
</style>